define('blog-editor',['tinymce-base', 'tinymce-plugins/image/plugin',], function(tinymce) {
	function initMCE(selector) {
		tinymce.init({
			selector: selector,
//			init_instance_callback: editorInitialized,
			content_css : "/css/community-post-content.min.css",
			body_class: 'community-post-content',

		    theme: "modern",
		    menubar : false,
		    statusbar : false,
		    // language : 'de', loaded by default
		   	plugins : 'wa5_headings, image, hr',
		   	toolbar1: "wa5_h2 | bold italic underline | removeformat | bullist numlist blockquote anchor | undo redo | hr image",
		
		   	// disallows e.g. <table width>
		   	schema: "html5-strict",
		   	
		   	height: 600,
		   	
		   	formats: {
				removeformat: [
					{block: 'h1', remove: 'all'},
					{block: 'h2', remove: 'all'},
					{block: 'blockquote', remove: 'all'},
					{selector: 'b,strong,em,i,font,u,strike,sub,sup', remove: 'all', split: true, expand: false, block_expand: true, deep: true},
					{selector: 'span', attributes: ['style', 'class'], remove: 'empty', split: true, expand: false, deep: true},
					{selector: '*', attributes: ['style', 'class'], split: false, expand: false, deep: true}
				]
		   	}
		});
	}
	
	return {
		initMCE: initMCE
	};
});

